import React from 'react'
import { Typography } from '@mui/material'

const UiTextTitleMedium = ({ text, children, sx, ...props }) => {
  return (
    <Typography
      sx={{
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 600,
        fontSize: '22px',
        lineHeight: '28px',
        letterSpacing: 0,
        ...sx,
      }}
      {...props}
    >
      {text ?? children}
    </Typography>
  )
}

export default UiTextTitleMedium
